import { useState, useEffect } from "react";
// import "./Controlmanagement";

// ─────────────────────── Styles ───────────────────────
const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
};

const getBadgeStyle = (isActive) => ({
    display: "inline-block",
    minWidth: 60,
    padding: "1px 1px",
    borderRadius: 4,
    fontWeight: "bold",
    color: "#fff",
    textTransform: "uppercase",
    backgroundColor: isActive ? "#28a745" : "#dc3545",
});
// ─────── Helper to get 09‑10‑25 style ───────
const formatShortDate = (isoString) =>
    new Date(isoString)
        .toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "2-digit" })
        .replaceAll("/", "-");


// ─────────────────── Helper Function ──────────────────
const getRemainderStatus = (endDate, isActive) => {
    if (!isActive) return "🔁 Please renew your subscription";

    const today = new Date();
    const end = new Date(endDate);
    const dayDiff = Math.ceil((end - today) / (1000 * 60 * 60 * 24));

    if (dayDiff < 0) return "❌ Expired";
    if (dayDiff <= 10) return `🔔 Expiring in ${dayDiff} day${dayDiff === 1 ? "" : "s"}`;
    return "✅ Active";
};

// ───────────────────── Component ───────────────────────
function Logisticssubscribedclients() {
    const fallbackData = [
        {
            id: 1,
            vendorName: "Mahesh Tiffins",
            vendorId: "VEND-001",
            email: "mahesh@example.com",
            mobileNumber: "9876543210",
            startDate: "2025-07-01",
            endDate: "2025-07-31",
            active: true,
        },
        {
            id: 2,
            vendorName: "Lakshmi Cafeteria",
            vendorId: "VEND-002",
            email: "lakshmi@example.com",
            mobileNumber: "9123456780",
            startDate: "2025-01-01",
            endDate: "2025-12-31",
            active: false,
        },
    ];

    const [data, setData] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch("https://backend.maamaas.com/subscription/api/admin/vendor_subscription/get-all")
            .then((res) => {
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return res.json();
            })
            .then((subs) => {
                const mapped = subs.map((s, idx) => ({
                    id: s.id ?? idx,
                    vendorName: s.vendorEnquiry?.name,
                    vendorId: s.vendorEnquiry?.vendorId,
                    email: s.vendorEnquiry?.email,
                    mobileNumber: s.vendorEnquiry?.mobileNumber,
                    businessVertical: s.vendorEnquiry?.businessVertical,
                    plan: s.subscriptionPlan?.planType,
                    startDate: s.startDate,
                    endDate: s.endDate,
                    active: s.active,
                    status: s.status,
                }));
                setData(mapped);
            })
            .catch((err) => {
                console.error("Subscriptions fetch error:", err);
                setError(err.message);
                setData(fallbackData);
            });
    }, []);

    return (
        <div className="row">
            <div className="col-lg-12">
                <div
                    className="ere34 d-flex justify-content-center"
                    style={{ height: "500px", overflow: "auto", scrollbarWidth: "none", marginTop: "20px" }}
                >
                    <table className="table" style={{ borderCollapse: "collapse", width: "100%" }}>
                        <thead>
                            <tr>
                                <th style={tableHeaderStyle}>SNO</th>
                                <th style={tableHeaderStyle}>VendorName</th>
                                <th style={tableHeaderStyle}>VendorID</th>
                                <th style={tableHeaderStyle}>Email</th>
                                <th style={tableHeaderStyle}>Phone</th>
                                <th style={tableHeaderStyle}>Vertical</th>
                                <th style={tableHeaderStyle}>Plan</th>
                                <th style={tableHeaderStyle}>StartDate</th>
                                <th style={tableHeaderStyle}>End Date</th>
                                <th style={tableHeaderStyle}>Status</th>
                                <th style={tableHeaderStyle}>Remainder</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.length === 0 ? (
                                <tr>
                                    <td colSpan="9" style={tableCellStyle}>
                                        {error ? `⚠️ ${error}` : "Loading…"}
                                    </td>
                                </tr>
                            ) : (
                                data.map((item, index) => (
                                    <tr key={item.id}>
                                        <td style={tableCellStyle}>{index + 1}</td>
                                        <td style={tableCellStyle}>{item.vendorName}</td>
                                        <td style={tableCellStyle}>{item.vendorId}</td>
                                        <td style={tableCellStyle}>{item.email}</td>
                                        <td style={tableCellStyle}>{item.mobileNumber}</td>
                                        <td style={tableCellStyle}>{item.businessVertical}</td>
                                        <td style={tableCellStyle}>{item.plan}</td>
                                        <td style={tableCellStyle}>{formatShortDate(item.startDate)}</td>
                                        <td style={tableCellStyle}>{formatShortDate(item.endDate)}</td>

                                        <td style={tableCellStyle}>
                                            {item.status}
                                        </td>
                                        <td style={tableCellStyle}>
                                            {getRemainderStatus(item.endDate, item.active)}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Logisticssubscribedclients;
